import React from "react";
import tw from "tailwind-styled-components";
import { Formik, Field, Form } from "formik";
import Loading from "../Loading";
import {
  InputGroup,
  FieldWrapper,
  Label,
  SubmitBtn,
  CombineInputGroup,
} from "../Styles/InputStyles";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Model from "../Model";

const EditDeviceModel = ({
  editSingleEntry,
  editEntryLoading,
  setEditUser,
  selectedData,
}) => {
  //const deviceData = data.find((item) => item.id === deviceId);
//console.log(selectedData);
  const InitialValues = {
    fName: selectedData?.fName,
    lName: selectedData?.lName,
    email: selectedData?.email,
    mobile: selectedData?.mobile,
    type: selectedData?.type,
    status: selectedData?.status,
  };

  const SubmitHandler = (values) => editSingleEntry(values);

  return (
    <Model width={`w-11/12 max-w-lg`} setOpenModel={setEditUser}>
      <Title>Edit Finance</Title>

      {editEntryLoading && <Loading />}

      {!editEntryLoading && (
        <Formik initialValues={InitialValues} onSubmit={SubmitHandler}>
          <Form>
            <Wrapper>
            <CombineInputGroup>
            <InputGroup>
                <Label htmlFor="email">Email</Label>
                <FieldWrapper>
                  <Field
                    type="text"
                    name="email"
                    id="email"
                    autoComplete="off"
                    className="truncate"
                    disabled
                  />
                </FieldWrapper>
              </InputGroup>
              {/* <InputGroup>
                <Label htmlFor="type">User Type</Label>
                <FieldWrapper $select={true}>
                  <Field required name="type" id="type" autoComplete="off">
                    {(props) => (
                      <Select
                        className="w-full h-full pl-2"
                        {...props.field}
                      >
                        <MenuItem value="2">Finance</MenuItem>
                        <MenuItem value="3">Registrar</MenuItem>
                        <MenuItem value="4">Ass. Registrar</MenuItem>
                      </Select>
                    )}
                  </Field>
                </FieldWrapper>
              </InputGroup> */}
              </CombineInputGroup>
              <CombineInputGroup>
                <InputGroup>
                  <Label htmlFor="fName">First Name</Label>
                  <FieldWrapper>
                    <Field
                      type="text"
                      name="fName"
                      id="fName"
                      autoComplete="off"
                      className="truncate"
                      required
                    />
                  </FieldWrapper>
                </InputGroup>

                <InputGroup>
                  <Label htmlFor="mobile">Last Name</Label>
                  <FieldWrapper>
                    <Field
                      type="text"
                      name="lName"
                      id="lName"
                      autoComplete="off"
                      className="truncate"
                      required
                    />
                  </FieldWrapper>
              </InputGroup>
              </CombineInputGroup>
              <CombineInputGroup>
              <InputGroup>
                  <Label htmlFor="mobile">Phone Number</Label>
                  <FieldWrapper>
                    <Field
                      type="number"
                      name="mobile"
                      id="mobile"
                      autoComplete="off"
                      className="truncate"
                      required
                    />
                  </FieldWrapper>
              </InputGroup>
              <InputGroup>
                <Label htmlFor="status">Status</Label>
                <FieldWrapper $select={true}>
                  <Field required name="status" id="status" autoComplete="off">
                    {(props) => (
                      <Select
                        className="w-full h-full pl-2"
                        {...props.field}
                      >
                        <MenuItem value="1">Active</MenuItem>
                        <MenuItem value="2">InActive</MenuItem>
                      </Select>
                    )}
                  </Field>
                </FieldWrapper>
              </InputGroup>
              </CombineInputGroup>           
            </Wrapper>
            <BtnWrapper>
              <SubmitBtn type="submit">Update</SubmitBtn>
            </BtnWrapper>
          </Form>
        </Formik>
      )}
    </Model>
  );
};

const Wrapper = tw.div`
grid gap-6 my-6 px-1 `;

const Title = tw.h2` text-lg md:text-xl lg:text-2xl text-gray-600 font-medium mb-6 text-center`;
const BtnWrapper = tw.div` w-full flex items-center justify-center space-x-10 mt-8`;

export default EditDeviceModel;
